import type { FC } from "react";

import * as CSS from "./radio-input.styles";
import type { RadioInputProps } from "./radio-input.types";

const RadioInput: FC<RadioInputProps> = ({
	checked,
	id,
	label,
	onCheck,
	disabled,
}) => {
	return (
		<CSS.Wrapper data-testid={id}>
			<CSS.Checkbox
				id={`radio-${id}`}
				disabled={disabled}
				type="radio"
				checked={checked}
				onChange={() => onCheck(!checked)}
			/>
			<CSS.Label $disabled={disabled} htmlFor={`radio-${id}`}>
				{label}
			</CSS.Label>
		</CSS.Wrapper>
	);
};

export default RadioInput;
